// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__AcWGP","socialList":"Footer_socialList__FziSM","copyRight":"Footer_copyRight__zajLS"};